import { ModalSweetAlert, Notificacion } from "@components/general/Alertas/Alertas";
import TitleDashboard from "@components/general/Titles/TitleDashboard";
import { faBook, faBrain, faEdit, faEye, faPowerOff, faTrash, faUser, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAsesorByGrupo } from "@helpers/httpRequests/httpRequestsUsuarios/asesores/httpRequestsAsesores";
import React, { useMemo, useState } from "react";
import { useEffect } from "react";
import { Button, Col, Container, Image, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import DesactivarUsuario from "../Modales/colaboradores/DesactivarUsuario";
import ModificarUsuario from "../Modales/colaboradores/ModificarUsuario";
import NuevoUsuario from "../Modales/colaboradores/NuevoUsuario";
import ReactivarUsuario from "../Modales/colaboradores/ReactivarUsuario";
import VerInfoUsuarioEmpresaial from "../Modales/colaboradores/VerInfoUsuarioEmpresarial";
import ListarAvanceEmpleado from "@components/general/MisAvances/components/ListarAvanceEmpleado";
import InvitarUsuarioExistente from "../Modales/colaboradores/InvitarUsuarioExistente";
import { getUsuariosByIdGrupo, getUsuariosInvitados } from "@helpers/httpRequests/httpRequestsGrupos/httpRequestsGrupos";
import VerInfoInvitados from "../Modales/colaboradores/VerInfoInvitados";
import { deleteUsusarioDelGrupo } from "@helpers/httpRequests/httpRequestsForoEmpresarial/httpRequestsForoEmpresarial";
import { getDatosUsuario, getTiempoPlataforma } from "@helpers/httpRequests/httpRequestsUsuarios/httpRequestsUsuarios";
import moment from "moment";
import { actualizarContadorGrupo, getAsesoresLectura, getUsuariosByFolio, obtenerEstadisticasEstudiante, validarAsesorLogeado } from "@helpers/httpRequests/httpRequestsGruposLectura/httpRequestsGruposLectura";
import NuevoRegistroMasivo from "../Modales/foroLectura/NuevoRegistroMasivo";
import { resolve } from "url";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { MaterialReactTable } from "material-react-table";

const ForoLectura = ({ isTabActive, tab, idGrupo, rol, usuarioLogeado, infoGrupo, folioGrupo, setContextValue,contextValue }) => {
    const { nombreCompleto, apellidos, avatarPerfil, idPersona, estudiantesRestantes, idCodigoRegion, folioContrato, idCredencial, usuarioTitular, nombreUsuario, cantidadEstudiantesGrupo } = usuarioLogeado;
    
    const [colaboradores, setColaboradores] = useState([]);

    const [asesores, setAsesores] = useState([]);

    const [empleadoRegistrado, setEmpleadoRegistrado] = useState(false);

    const [empleadoDesactivado, setEmpleadoDesactivado] = useState(false);

    const [empleadoModificado, setEmpleadoModificado] = useState(false);

    const [empleadoReactivado, setEmpleadoReactivado] = useState(false);

    const [usuarioAgregado, setUsuarioAgregado] = useState(false);

    const [usuarioEliminado, setUsuarioEliminado] = useState(false);

    const [mostrarGraficaEmpleado, setMostrarGraficaEmpleado] = useState(false);

    const [mostrarGraficaInvitado, setMostrarGraficaInvitado] = useState(false);

    const [idPerfilEmpleado, setIdPerfilEmpleado] = useState(0);

    const [usuariosInvitados, setUsuariosInvitados] = useState([]);

    const [nombreEmpleadoSeleccionado, setNombreEmpleadoSeleccionado] = useState("");

    const [yearsPlataforma, setYearsPlataforma] = useState(0);

    const [mesesPlataforma, setMesesPlataforma] = useState(0);

    const [diasPlataforma, setDiasPlataforma] = useState(0);

    const [horasPlataforma, setHorasPlataforma] = useState(0);

    const [minutosPlataforma, setMinutosPlataforma] = useState(0);

    const [estudiantesDisponibles, setEstudiantesDisponibles] = useState(0);

    const [registroMasivoCompletado, setRegistroMasivoCompletado] = useState(false);

    const [showLoaderColaboradores, setShowLoaderColaboradores] = useState(false);

    /**MODALES PARA:
     * -AVANCE GENERAL.
     * -NUEVO USUARIO-
     * ACCIONES DEL USUARIO EMPRESARIAL (AVANCE, VER INFORMACION, MODIFICAR PERFIL).
     */

    const handleVerInformacion = ({ currentTarget }) => {
        const rowIndex = currentTarget.id;

        ModalSweetAlert({
            title: "Información del colaborador",
            html: <VerInfoUsuarioEmpresaial colaborador={colaboradores[rowIndex]} />,
            showConfirmButton: false,
            showCloseButton: true,
            width: "700px",
        });
    };

    const handleVerInfoInvitado = ({ currentTarget }) => {
        const rowIndex = currentTarget.id;

        ModalSweetAlert({
            title: "Información del invitado",
            html: <VerInfoInvitados infoUsuario={usuariosInvitados[rowIndex]} />,
            showConfirmButton: false,
            showCloseButton: true,
            width: "700px",
        });
    };

    const handleNuevoColaborador = ({ currentTarget }) => {
        const rowIndex = currentTarget.id;

        ModalSweetAlert({
            title: "Nuevo integrante del foro",
            html: <NuevoUsuario usuarioLogeado={usuarioLogeado} colaboradores={colaboradores} usuarioConvenioLectura={true} setEmpleadoRegistrado={setEmpleadoRegistrado} folioGrupo={folioGrupo} colaborador={colaboradores[rowIndex]} idRegion={idCodigoRegion} />,
            showConfirmButton: false,
            showCloseButton: true,
            width: "700px",
        });
    };

    const handleModificarUsuario = ({ currentTarget }) => {
        const rowIndex = currentTarget.id;

        ModalSweetAlert({
            title: "Editar información",
            html: <ModificarUsuario setEmpleadoModificado={setEmpleadoModificado} colaborador={colaboradores[rowIndex]} />,
            showConfirmButton: false,
            showCloseButton: true,
            width: "1000px",
        });
    };

    const handleDesactivarUsuario = ({ currentTarget }) => {
        const rowIndex = currentTarget.id;

        ModalSweetAlert({
            title: "Deshabilitar colaborador",
            html: <DesactivarUsuario setEmpleadoDesactivado={setEmpleadoDesactivado} colaborador={colaboradores[rowIndex]} />,
            showConfirmButton: false,
            showCloseButton: true,
            width: "700px",
        });
    };

    const handleReactivarUsuario = ({ currentTarget }) => {
        const rowIndex = currentTarget.id;

        ModalSweetAlert({
            title: "Reactivar colaborador",
            html: <ReactivarUsuario setEmpleadoReactivado={setEmpleadoReactivado} colaborador={colaboradores[rowIndex]} />,
            showConfirmButton: false,
            showCloseButton: true,
            width: "700px",
        });
    };


      const nuevoRegistroMasivo = ({ currentTarget }) => {
        const rowIndex = currentTarget.id;

        ModalSweetAlert({
            title: "Registrar múltiples usuarios",
            html: <NuevoRegistroMasivo usuarioLogeado={usuarioLogeado} colaboradores={colaboradores} folioContrato={folioContrato} setRegistroMasivoCompletado={setRegistroMasivoCompletado} idGrupo={idGrupo}/>,
            showConfirmButton: false,
            showCloseButton: true,
            width: "700px",
        });
    };


    const [adminForo, setAdminForo] = useState(false);

    const [avancesColaboradores, setAvancesColaboradores] = useState([]);

    const getAvancesUsuariosFiltrados = async(usuarios) => {
        return new Promise(async(resolve, reject) => {
            try {
                console.log(usuarios);
                
                const avancesAux = [];
                const colaboradoresAux = usuarios;

                for (const usuario in usuarios) {
                    if (!Object.hasOwn(usuarios, usuario)) continue;
                    
                    const infoUsuario = usuarios[usuario];
                    
                    const avanceUsuario = await obtenerEstadisticasEstudiante({correo: infoUsuario.correo})

                    console.log(avanceUsuario)

                    colaboradoresAux[usuario].palabrasPorMinuto = avanceUsuario.avancePersonal.palabrasPorMinuto; 
                    colaboradoresAux[usuario].comprension = avanceUsuario.avancePersonal.comprension ;

                    avancesAux.push({
                        comprension: avanceUsuario.avancePersonal.comprension,
                        palabrasPorMinuto: avanceUsuario.avancePersonal.palabrasPorMinuto
                    })

                    avancesColaboradores.push({
                        comprension: avanceUsuario.avancePersonal.comprension,
                        palabrasPorMinuto: avanceUsuario.avancePersonal.palabrasPorMinuto
                    })
                }

                console.log(colaboradoresAux);


                const ordenado = colaboradoresAux.sort((a, b) => b.palabrasPorMinuto - a.palabrasPorMinuto);

                setColaboradores(ordenado);
                

                resolve(true);
            } catch (error) {
                console.log("Error al recuperar los avances de los usuarios filtrados", error);
                reject(false);
            }
        })
    }

    const obtenerUsuariosEmpresariales = async (esAdmin) => {
        try {
            console.log({ esAdmin })

            const { data } = await getUsuariosByFolio(folioContrato);

            console.log("usuarios empresariales: ", data);

            let usuariosFiltrados = data;

            // const colab = [
            //     {
            //         avatarPerfil: '',
            //         nombreCompleto: "Victor Manuel",
            //         apellidos: "Mendez Calderon",
            //         correo: "gcadmon@outlook.com",
            //         correoDocente: 'rotorres@uveg.edu.mx',
            //     },
            //      {
            //         avatarPerfil: '',
            //         nombreCompleto: "Jose de Jesus",
            //         apellidos: "Mendez Calderon",
            //         correo: "TBC250001007@es.uveg.edu.mx",
            //         correoDocente: "rotorres@uveg.edu.mx",
            //     },
            //     {
            //         avatarPerfil: '',
            //         nombreCompleto: "Perlita",
            //         apellidos: "Cascaruda",
            //         correo: "TBC250001009@es.uveg.edu.mx",
            //         correoDocente: "rotorres@uveg.edu.mx",
            //     },
            //     {
            //         avatarPerfil: '',
            //         nombreCompleto: "Monito",
            //         apellidos: "De la selva",
            //         correo: "TBC250001006@es.uveg.edu.mx",
            //         correoDocente: "rotorres@uveg.edu.mx",
            //     }
            // ]

            // usuariosFiltrados = colab;

            if (!esAdmin) {
                if (Array.isArray(usuariosFiltrados)) {
                    usuariosFiltrados = usuariosFiltrados.filter(data => data.correoDocente === usuarioLogeado.correo);
                    setShowLoaderColaboradores(true)
                    await getAvancesUsuariosFiltrados(Array.isArray(usuariosFiltrados) ? usuariosFiltrados : [usuariosFiltrados]);

                } else {
                    setShowLoaderColaboradores(true)
                    await getAvancesUsuariosFiltrados(Array.isArray(usuariosFiltrados) ? usuariosFiltrados : [usuariosFiltrados]);

                    usuariosFiltrados = data.correoDocente === usuarioLogeado.correo ? data : [];
                }
            }

            setShowLoaderColaboradores(false);

            console.log(usuariosFiltrados);

            if (Array.isArray(usuariosFiltrados)) {
                setColaboradores(usuariosFiltrados);
            } else {
                setColaboradores([usuariosFiltrados]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {

        const validarAsesor = async() => {
            try {
                await validarAsesorLogeado(usuarioLogeado.correo);
                setAdminForo(true);
                console.log('es un asesor registrado');
            } catch (error) {
                console.log('No se ha podido validar al asesor, no se encuentra registrado o hubo un error.')
            }
        }

        validarAsesor();


        const obtenerAsesor = async () => {
            try {
                const { data } = await getAsesoresLectura();

                console.log("ASESORES DEL GRUPO: ", data);

                let asesoresFiltrados = data;

                if (Array.isArray(data)) {
                    if (data[0].nombreUsuario !== nombreUsuario) {
                        asesoresFiltrados = data.filter(data => data.correo === usuarioLogeado.correo);
                    }
                }

                console.log(asesoresFiltrados);

                if (Array.isArray(asesoresFiltrados)) {
                    setAsesores(asesoresFiltrados);
                    
                } else {
                    setAsesores([asesoresFiltrados]);
                    setEstudiantesDisponibles(asesoresFiltrados.estudiantesRestantes);
                    
                }
            } catch (error) {
                console.log(error);
            }
        };

        // obtenerUsuariosInvitados();


        obtenerAsesor();
    }, []);

    useEffect(() => {
            obtenerUsuariosEmpresariales(adminForo);
    }, [adminForo])
    

    useEffect(() => {
        if (empleadoRegistrado || empleadoDesactivado || empleadoReactivado || empleadoModificado || usuarioAgregado || usuarioEliminado || registroMasivoCompletado) {

            obtenerUsuariosEmpresariales(adminForo);

            const obtenerAsesor = async () => {
                try {
                    const { data } = await getAsesoresLectura();
                    let asesoresFiltrados = data;

                    if (Array.isArray(data)) {
                        if (data[0].nombreUsuario !== nombreUsuario) {
                            asesoresFiltrados = data.filter(data => data.correo === usuarioLogeado.correo);
                        }
                    }

                    if (Array.isArray(asesoresFiltrados)) {
                        setAsesores(asesoresFiltrados);
                    } else {
                        setAsesores([asesoresFiltrados]);
                        setEstudiantesDisponibles(asesoresFiltrados.estudiantesRestantes);
                    }
                } catch (error) {
                    console.log(error);
                }
            };

            obtenerAsesor();


            const descontarEstudianteGrupo = async () => {
                try {
                    // await actualizarContadorGrupo(folioContrato, idGrupo);

                    const { data } = await getDatosUsuario({
                        tipoUsuario: rol,
                        idCredencial: idCredencial,
                        usuarioTitular: usuarioTitular,
                    });
        
                    const [datosUsuarioActualizados] = data;
        
                    setContextValue({
                        ...contextValue,
                        usuarioLogeado: datosUsuarioActualizados,
                    });

                    setEstudiantesDisponibles(datosUsuarioActualizados.estudiantesRestantes)
                } catch (error) {
                    console.log('Error al descontar un estudiante a los estudiantes restantes del grupo.')
                }
            }

            descontarEstudianteGrupo();

            setEmpleadoRegistrado(false);

            setEmpleadoDesactivado(false);

            setEmpleadoReactivado(false);

            setEmpleadoModificado(false);

            setUsuarioAgregado(false);

            setUsuarioEliminado(false);
        }
    }, [empleadoRegistrado, empleadoDesactivado, empleadoReactivado, empleadoModificado, usuarioAgregado, usuarioEliminado, registroMasivoCompletado]);

    useEffect(() => {
     console.log(avancesColaboradores)
    }, [avancesColaboradores])


    const columnasDocentes = useMemo(() => [
                // {
                //     accessorFn: (row) => (`${row.codigoRegion}-${row.folioContrato}`),
                //     header: "Folio",
                //     size: 50,
                // },
                {
                    accessorFn: (row) => `${row.nombreCompleto} ${row.apellidos}`,
                    header: "Nombre completo",
                },
               
            ]);

    const columnas = useMemo(() => [
                // {
                //     accessorFn: (row) => (`${row.codigoRegion}-${row.folioContrato}`),
                //     header: "Folio",
                //     size: 50,
                // },
                {
                    accessorFn: (row) => `${row.nombreCompleto} ${row.apellidos}`,
                    header: "Nombre completo",
                },
               
               
                {
                    accessorFn: (row) => (
                         <Col className="col-12 col-md-auto mt-5 mt-lg-0 text-start">
                            <p><FontAwesomeIcon color="brown" size="lg" icon={faBook}/> <b>{row.palabrasPorMinuto}</b> ppm</p>

                            <p><FontAwesomeIcon color="pink" size="lg" icon={faBrain}/> <b>{row.comprension}%</b> de comprensión</p>
                        </Col>
                    ),
                    // accessorKey: "estatusCredencial",
                    header: "Estado",
                    // size: 50,
                },
            ]);
    
 // 👇 Filtro inicial si el usuario no es admin
        const [columnFilters, setColumnFilters] = useState(
            !adminForo
            ? [
                {
                    id: 'correoDocente', // <- columna por la que filtras
                    value: usuarioLogeado.correo, // <- valor a filtrar
                },
                ]
            : []
        );
    return (
        isTabActive && (
            <>
                {(rol === "asesor_lectura" && adminForo) && (
                    <Container>
                        <Row className="mt-5  mb-5 justify-content-start">
                            <Col className="col-auto p-0">
                                <Col className="col-auto p-0">
                                    {/* //TODO Este enlace de avance general nos generará un reporte general del grupo */}
                                    {/* <Button className='mx-1'><FontAwesomeIcon icon={faChartBar} /> Avance</Button> */}

                                    {(estudiantesRestantes - colaboradores.length) > 0 ? (
                                        <>
                                            <div className="mb-3">
                                                <h5>Registros disponibles: <b>{cantidadEstudiantesGrupo - colaboradores.length}</b></h5>
                                            </div>
                                            <div>
                                                <Button onClick={handleNuevoColaborador} className="mx-1 " variant="success">
                                                    <FontAwesomeIcon icon={faUserPlus} /> Nuevo colaborador
                                                </Button>

                                                <Button onClick={nuevoRegistroMasivo} className="mx-1 " variant="primary">
                                                    <FontAwesomeIcon icon={faUserPlus} /> Registrar múltiples usuarios
                                                </Button>
                                            </div>
                                        </>
                                    ) : null}
                                </Col>
                            </Col>
                        </Row>
                    </Container>
                )}
                <Container className="pb-5 mb-" style={{ width: "75%" }}>
                    {!mostrarGraficaInvitado && !mostrarGraficaEmpleado && (
                        <Row className="mt-4 justify-content-between">
                            <Col className="col-auto">
                                <TitleDashboard title={"Docentes"} />
                            </Col>
                            <Col className="d-flex align-items-center col-auto">
                                <small>
                                    <b> {`(${asesores.length} ${asesores.length > 1 ? "docentes" : asesores.length === 0 ? "docentes" : "docente"})`}</b>
                                </small>
                            </Col>
                        </Row>
                    )}
                    {/* //*SI EL ASESOR ES QUIEN ESTA LOGEADO, MOSTRAR DIRECTAMENTE LA INFORMACION DEL USUARIO LOGEADO */}

                    {/* //*HACER UN MAPEO DE LOS ASESORES  */}
                    {!mostrarGraficaInvitado &&
                        !mostrarGraficaEmpleado &&
                        (asesores.length > 0 ? (
                            // asesores.map((asesor, key) => (
                            //     <Row key={key} className="mt-3">
                            //         <Col className="col-12 col-md-auto text-center">
                            //             <img
                            //                 className="rounded-circle"
                            //                 src={`${
                            //                     rol !== "asesor"
                            //                         ? asesor.avatarPerfil === "" || asesor.avatarPerfil === null
                            //                             ? require("@assets/images/avatar.png")
                            //                             : asesor.avatarPerfil
                            //                         : asesor.avatarPerfil === "" || asesor.avatarPerfil === null
                            //                         ? require("@assets/images/avatar.png")
                            //                         : avatarPerfil
                            //                 }`}
                            //                 width="50"
                            //                 height="50"
                            //                 alt="asesor"></img>
                            //             <span className="mx-4">{rol !== "asesor" ? `${asesor.nombreCompleto} ${asesor.apellidos}` : `${nombreCompleto} ${apellidos}`}</span>
                            //         </Col>
                            //     </Row>
                            // ))

                            <Row className="mt-5 mb-5">
                                        <Col>
                                        {/* <p><small>Utilíza <code>shift + rueda del mouse</code> sobre los registros para ver toda la información</small></p> */}
                        
                                            <MaterialReactTable
                                                localization={MRT_Localization_ES}
                                                columns={columnasDocentes}
                                                data={asesores}
                                                state={{
                                                    columnFilters, // <- estado controlado del filtro
                                                }}
                                                onColumnFiltersChange={setColumnFilters} // <- importante para MRT v2
                                                enableColumnFilters={adminForo} // los no admin no pueden cambiar filtros
                                                enableGlobalFilter={adminForo} // los no admin no pueden buscar globalmente
                                                enableSorting
                                                enableColumnActions={adminForo}
                                                enableFilterMatchHighlighting={false}
                                                // enableRowActions
                                                // positionActionsColumn="last"
                                                // renderRowActions={({ row, table }) => (
                                                //     <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                                                //         <IconButton color="primary" onClick={handleMenuSelection} id={row.original.idPersona}>
                                                //             <MenuIcon />
                                                //         </IconButton>
                                                //     </Box>
                                                // )}
                                            />
                                        </Col>
                                        
                                    </Row>
                        ) : (
                            <Row className="mt-3">
                                <Col className="text-center mt-5" style={{ color: "grey" }}>
                                    <FontAwesomeIcon icon={faUser} className="mb-3" size="4x" />
                                    <h4>El grupo no tiene asesores asignados</h4>
                                </Col>
                            </Row>
                        ))}

                    {!mostrarGraficaInvitado &&
                        (colaboradores.length > 0 ? (
                            !mostrarGraficaEmpleado ? (
                                <>
                                    <Row className="mt-5 justify-content-between">
                                        <Col className="col-auto">
                                            <TitleDashboard title={`Estudiantes `} />
                                        </Col>
                                        <Col className="d-flex align-items-center col-auto">
                                            <small>
                                                <b> {`(${colaboradores.length} ${colaboradores.length > 1 ? "estudiantes" : colaboradores.length === 0 ? "estudiantes" : "estudiante"})`}</b>
                                            </small>
                                        </Col>
                                    </Row>

                                    {/* {colaboradores.map((colaborador, key) => (
                                        <Row key={key} className="mt-5 mb-3 justify-content-between">
                                            <Col className="col-12 col-md-auto text-center">
                                                <img
                                                    className="rounded-circle"
                                                    src={colaborador.avatarPerfil === null || colaborador.avatarPerfil === "" ? require("@assets/images/avatar.png") : colaborador.avatarPerfil}
                                                    width="50"
                                                    height="50"
                                                    alt="asesor"></img>
                                                <span className="mx-4">{`${colaborador.nombreCompleto} ${colaborador.apellidos}`} </span>
                                            </Col>

                                            <Col className="col-12 col-md-auto mt-5 mt-lg-0 text-start">
                                                <p><FontAwesomeIcon color="brown" size="lg" icon={faBook}/> <b>{colaborador.palabrasPorMinuto}</b> ppm</p>

                                                <p><FontAwesomeIcon color="pink" size="lg" icon={faBrain}/> <b>{colaborador.comprension}%</b> de comprensión</p>
                                            </Col>
                                           
                                        </Row>
                                    ))} */}

                                    <Row className="mt-5 mb-5">
                                        <Col>
                                        {/* <p><small>Utilíza <code>shift + rueda del mouse</code> sobre los registros para ver toda la información</small></p> */}
                        
                                            <MaterialReactTable
                                                localization={MRT_Localization_ES}
                                                columns={columnas}
                                                data={colaboradores}
                                                state={{
                                                    columnFilters, // <- estado controlado del filtro
                                                }}
                                                onColumnFiltersChange={setColumnFilters} // <- importante para MRT v2
                                                enableColumnFilters={adminForo} // los no admin no pueden cambiar filtros
                                                enableGlobalFilter={adminForo} // los no admin no pueden buscar globalmente
                                                enableSorting
                                                enableColumnActions={adminForo}
                                                enableFilterMatchHighlighting={false}
                                                // enableRowActions
                                                // positionActionsColumn="last"
                                                // renderRowActions={({ row, table }) => (
                                                //     <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                                                //         <IconButton color="primary" onClick={handleMenuSelection} id={row.original.idPersona}>
                                                //             <MenuIcon />
                                                //         </IconButton>
                                                //     </Box>
                                                // )}
                                            />
                                        </Col>
                                        
                                    </Row>
                                </>
                            ) : (
                                <ListarAvanceEmpleado
                                    minutosPlataformaEmpleado={minutosPlataforma}
                                    horasPlataformaEmpleado={horasPlataforma}
                                    mesesPlataformaEmpleado={mesesPlataforma}
                                    diasPlataformaEmpleado={diasPlataforma}
                                    yearsPlataformaEmpleado={yearsPlataforma}
                                    idPerfilEmpleado={idPerfilEmpleado}
                                    setMostrarGraficaInvitado={setMostrarGraficaInvitado}
                                    setMostrarGraficaEmpleado={setMostrarGraficaEmpleado}
                                    nombreEmpleadoSeleccionado={nombreEmpleadoSeleccionado}
                                    mostrarGraficaEmpleado={mostrarGraficaEmpleado}
                                    mostrarGraficaInvitado={mostrarGraficaInvitado}
                                />
                            )
                        ) : (
                            showLoaderColaboradores ? (
                                <Row className="mt-3 mb-5">
                                    <Col className="text-center mt-5" style={{ color: "grey" }}>
                                        <Spinner variant="warning" size="lg" />
                                        <h3 className="mt-4">Cargando...</h3>
                                    </Col>
                                </Row>
                            ) : (
                                <Row className="mt-3 mb-5">
                                    <Col className="text-center mt-5" style={{ color: "grey" }}>
                                        <FontAwesomeIcon icon={faUser} className="mb-3" size="4x" />
                                        <h4>Ningún estudiante se ha registrado por el momento</h4>
                                    </Col>
                                </Row>
                            )
                        ))}

                </Container>
            </>
        )
    );
};

export default ForoLectura;
